import React from "react";

const StatsCard = ({ icon: Icon, label, value }) => {
  return (
    <div className="flex items-center gap-4 bg-white border border-[#D1D5DB] rounded-xl p-5 shadow-sm">
      <div className="p-3 rounded-lg bg-[#E3F2FDB2] textcolor">
        <Icon className="w-10 h-10" />
      </div>
      <div className="space-y-2">
        <p className="text-base textblack font-medium">{label}</p>
        <p className="text-2xl font-semibold textblack">{value}</p>
      </div>
    </div>
  );
};

export default StatsCard;